import React from 'react';
import { BrandColor } from '@Shared.Angular/@types/brandColor';
import { getService } from '@Client/runner.hooks/useService';
import { RunnerPageDescription } from '@Client/runner.directives/common/PageDescription';
import { CreationHubItem } from './CreationHubItem';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import EmptyState from '@Client/runner.directives/common/EmptyState';

export const CreationHubPage = () => {
  const APP_CONFIG = getService('APP_CONFIG');
  const $state = getService('$state');
  const permissionsService = getService('permissionsService');

  if (
    !permissionsService.currentUserHasAnyOfPermissions([
      FlowinglyPermissions.FLOWMODEL_CREATE,
      FlowinglyPermissions.PROCEDURE_CREATE
    ])
  ) {
    return (
      <div className="no-permission-creation-hub">
        <EmptyState summaryText="You do not have permission to create." />
      </div>
    );
  }

  return (
    <div className="creation-hub">
      <RunnerPageDescription
        pageHeaderText="Creation Hub"
        pageDescription={`Choose what you'd like to build in ${APP_CONFIG.brandingName}`}
      />
      <div className="creation-hub-page">
        {APP_CONFIG.enableProcedures && (
          <CreationHubItem
            iconClass="fa-file-magnifying-glass"
            title="Standard Operating Procedure"
            description="Document repeatable processes step-by-step so your team executes consistently."
            actionText="Get started"
            color={BrandColor.Mauve}
            onClick={() => $state.go(STATE_MAPPINGS.creationHubProcedure)}
          />
        )}
        {APP_CONFIG.allowProcessMap && (
          <CreationHubItem
            iconClass="fa-file-alt"
            title="Process Map"
            description="Visualise how work flows across people, systems, and decisions."
            actionText="Get started"
            color={BrandColor.Redish}
            onClick={() => $state.go(STATE_MAPPINGS.creationHubProcessMap)}
          />
        )}
        {APP_CONFIG.allowWorkflow && (
          <CreationHubItem
            iconClass="fa-merge"
            title="Workflow Automation"
            description="Turn a process into an automated, trackable workflow with forms and approvals."
            actionText="Get started"
            color={BrandColor.Grape}
            onClick={() => $state.go(STATE_MAPPINGS.creationHubWorkflow)}
          />
        )}
      </div>
    </div>
  );
};
